import React, { useState } from 'react'
import { AiOutlinePlus, AiOutlineMinus } from "react-icons/ai";
import AnimateHeight from 'react-animate-height';
import { ERCText } from 'components/text';

const FaqDropdown = ({ header, smallText }) => {
  const [toggle, setToggle] = useState(false);

  return (
    <div className="shadow-lg rounded-lg bg-white w-full max-w-4xl mx-auto">
      <div className="w-full">
        <ul className="w-full">
          <li className="flex justify-between items-center text-[#00296B] h-16">
            <div
              className={`flex justify-between items-center w-full px-5 py-4 cursor-pointer ${
                toggle ? 'bg-[#00296B] text-white' : 'bg-white text-[#00296B]'
              }`}
              onClick={() => setToggle(!toggle)}
            >
              <ERCText
                color={`${toggle ? '#fff' : '#00296B'}`}
                inline={false}
                lHeight="24px"
                size="16px"
                weight="600"
              >
                {header}
              </ERCText>
              {toggle ? (
                <AiOutlineMinus className="cursor-pointer text-white" />
              ) : (
                <AiOutlinePlus className="cursor-pointer text-[#00296B]" />
              )}
            </div>
          </li>
        </ul>
        <AnimateHeight
          id="example-panel"
          duration={500}
          height={toggle ? 'auto' : 0}
        >
          <ERCText
            style={{ padding: '24px' }}
            weight="400"
            size="20px"
            lHeight="24px"
            align="justify"
            color="#0C0C0C"
          >
            {smallText}
          </ERCText>
        </AnimateHeight>
      </div>
    </div>
  );
}

export default FaqDropdown;
